"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _PricingSelectors = require("../../../selectors/PricingSelectors");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _ChargeTypes = require("self-service-api/constants/ChargeTypes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../../utils/responsiveBreakpoints"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _PriceDisplay = _interopRequireDefault(require("../../common/pricing/PriceDisplay"));

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var _PurchaseMotionSelectors = require("../../../selectors/PurchaseMotionSelectors");

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _PurchaseMotionsLocations = require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations");

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    min-height: 0;\n    width: 100% !important;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Title = _styledComponents.default.div.withConfig({
  displayName: "OptionalItem__Title",
  componentId: "sc-1vdwssr-0"
})(["font-size:14px;font-weight:600;"]);

var Price = _styledComponents.default.span.withConfig({
  displayName: "OptionalItem__Price",
  componentId: "sc-1vdwssr-1"
})(["font-size:14px;"]);

var StyledSelectableBox = (0, _styledComponents.default)(_UISelectableBox.default).withConfig({
  displayName: "OptionalItem__StyledSelectableBox",
  componentId: "sc-1vdwssr-2"
})(["min-height:220px;margin:12px 0;", ";"], _responsiveBreakpoints.default.tablet(_templateObject()));

function OptionalItem(_ref) {
  var merchandiseId = _ref.merchandiseId,
      selected = _ref.selected,
      onSelectedChange = _ref.onSelectedChange,
      currencyCode = _ref.currencyCode,
      products = _ref.products,
      _ref$restricted = _ref.restricted,
      restricted = _ref$restricted === void 0 ? false : _ref$restricted,
      restrictionKey = _ref.restrictionKey,
      touchlessEligible = _ref.touchlessEligible;
  var calculatePriceAndItemConfig = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculatePriceAndItemConfigSelector);
  var priceObject = calculatePriceAndItemConfig({
    merchandiseId: merchandiseId
  });
  var recurring = products[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  var price = recurring ? priceObject.monthly.calculatedPrice : priceObject.oneTimeFee.calculatedPrice;
  var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchandiseId];
  return _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 6
    },
    "data-selenium-class": "optional-item",
    "data-selected": selected,
    "data-touchless-eligible": touchlessEligible,
    "data-merch-id": merchandiseId,
    className: "flex-row"
  }, _react.default.createElement(_UITooltip.default, {
    title: restrictionKey && _react.default.createElement(_FormattedMessage.default, {
      message: "addonRestrictions." + restrictionKey
    })
  }, _react.default.createElement(StyledSelectableBox, {
    selected: selected,
    onSelectedChange: onSelectedChange,
    disabled: restricted
  }, _react.default.createElement("div", {
    className: "text-start"
  }, _react.default.createElement(Title, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.merchandise." + billingNameKey + ".title"
  })), _react.default.createElement("div", null, _react.default.createElement(Price, null, _react.default.createElement(_PriceDisplay.default, {
    price: price,
    currencyCode: currencyCode
  }), recurring && _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonth"
  })), !recurring && _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedMessage.default, {
    className: "m-left-1",
    message: "pricingPage.notes.oneTimeFeeParentheses"
  }))), _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "pricing-pages.merchandise." + billingNameKey + ".paragraph"
  }))))));
}

OptionalItem.propTypes = {
  merchandiseId: _propTypes.default.number.isRequired,
  selected: _propTypes.default.bool.isRequired,
  onSelectedChange: _propTypes.default.func.isRequired,
  currencyCode: _propTypes.default.string.isRequired,
  products: _propTypes.default.object.isRequired,
  restricted: _propTypes.default.bool,
  restrictionKey: _propTypes.default.string,
  touchlessEligible: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    touchlessEligible: (0, _PurchaseMotionSelectors.purchaseMotionsSelector)(state, _PurchaseMotionsLocations.MERCH_CARD, props.merchandiseId).includes(_PurchaseMotionTypes.BUY_TOUCHLESS)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(OptionalItem);

exports.default = _default;
module.exports = exports.default;